'use client';

import { useEffect, useState } from 'react';
import { H1 } from '../styled/typography';
import CheckSVG from '../../public/img/check-red.svg';
import { FilterQuery, ISortFilter } from '../../models/filters';

export default function SortFilter({
  query,
  setQuery,
  filtersData,
  sortTypes,
}: {
  query: FilterQuery;
  setQuery: (query: FilterQuery) => void;
  filtersData: ISortFilter | null;
  sortTypes: ISortFilter[];
}) {
  const [activeSort, setActiveSort] = useState<string | null>(null);

  useEffect(() => {
    setActiveSort(filtersData?.slug || null);
  }, [filtersData]);

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <H1
        css={{
          fontFamily: 'Montserrat',
          fontSize: '24px !important',
          fontWeight: 900,
        }}
      >
        Сортировка
      </H1>
      <div
        css={{
          width: '100%',
          height: 2,
          boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
          marginTop: 14,
        }}
      />
      {sortTypes.map((sort) => (
        <button
          type='button'
          key={sort.slug}
          css={{
            width: '100%',
            height: 75,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
            textAlign: 'left',
            fontSize: 18,
            fontWeight: 700,
            fontFamily: 'Montserrat',
            color: '#333',
            letterSpacing: 0,
          }}
          onClick={() => {
            setQuery({
              ...query,
              filters: {
                ...query.filters,
                sort: sort.slug === query.filters.sort ? [] : sort.slug,
                pages: [],
              },
              isDataFromServer: false,
            });
          }}
        >
          {sort.description} {sort.slug === activeSort && <CheckSVG />}
        </button>
      ))}
    </div>
  );
}
